import React from 'react';
import { colors, fonts } from '../tokens';

/**
 * PricingCard – einheitliche Preisoptionen-Karte mit Header, Preisblock und Tabelle.
 * Beide Optionen (Einmalzahlung / Jährlich) nutzen dieselbe Komponente.
 */
export const PricingCard = ({
  headerBg,
  headerLabel,
  headerSub,
  priceLabel,
  priceValue,
  priceUnit = '€',
  priceFootnote,
  priceColor = colors.navy,
  rows = [],
}) => (
  <div
    style={{
      background: 'white',
      borderRadius: '10px',
      overflow: 'hidden',
      border: '1.5px solid rgba(18,42,92,0.12)',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <div style={{ background: headerBg, padding: '10px 16px' }}>
      <p style={{ fontFamily: fonts.display, fontSize: '10px', fontWeight: 700, color: 'white', letterSpacing: '0.05em', textTransform: 'uppercase' }}>{headerLabel}</p>
      <p style={{ fontFamily: fonts.body, fontSize: '8.5px', color: 'rgba(255,255,255,0.55)', marginTop: '1px' }}>{headerSub}</p>
    </div>
    <div
      style={{
        padding: '12px 16px',
        background: priceColor === colors.orange ? 'rgba(224,112,0,0.05)' : 'rgba(18,42,92,0.04)',
        borderBottom: priceColor === colors.orange ? '1px solid rgba(224,112,0,0.15)' : '1px solid rgba(18,42,92,0.1)',
      }}
    >
      <p style={{ fontFamily: fonts.body, fontSize: '8.5px', fontWeight: 700, color: colors.slateLight, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '3px' }}>{priceLabel}</p>
      <p style={{ fontFamily: fonts.display, fontSize: '26px', fontWeight: 800, color: priceColor, letterSpacing: '-0.02em', lineHeight: 1 }}>
        {priceValue},- <span style={{ fontSize: '14px', fontWeight: 600 }}>{priceUnit}</span>
      </p>
      <p style={{ fontFamily: fonts.body, fontSize: '8.5px', color: colors.slateLight, marginTop: '2px' }}>{priceFootnote}</p>
    </div>
    <table className="pricing-table" style={{ flex: 1 }}>
      <tbody>
        {rows.map((row, i) => (
          <tr key={i}>
            <td style={{ fontWeight: 600, color: colors.navy, fontSize: '9.5px', width: '50%' }}>{row.label}</td>
            <td style={{ fontSize: '9.5px', ...(row.valueStyle || {}) }}>{row.value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
